<template>
  <v-form ref="form" v-model="valid" :lazy-validation="true">
    <v-card>
      <div class="message-form__content">
        <v-card-title>
          <span class="headline">{{ titlePrefix }} Queue Group</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            name="queuegroupname"
            label="Name (Shown in the app)"
            v-model="ownItem.name"
            :rules="stringValidation"
          />
        </v-card-text>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" color="primary" :disabled="isSaving">Cancel</v-btn>
        <v-btn depressed :disabled="!valid" :loading="isSaving" color="primary" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      valid: true,
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      ownItem: {}
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['queuegroups.create', 'queuegroups.update']);
    },
    titlePrefix () {
      return this.ownItem.id ? 'Edit' : 'Add';
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (newVal) {
        this.setOwnItem(newVal);
      }
    }
  },
  methods: {
    setOwnItem (item) {
      if (item) {
        this.ownItem = Object.assign({}, item);
      } else {
        this.ownItem = {};
      }

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return;
      }
      const item = Object.assign({}, this.ownItem);
      this.$emit('submit', item);
    },
    cancel () {
      this.$emit('cancel')
    },
    reset () {
      this.setOwnItem(null);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
